<div class="home-page">
  <app-home-header class="home-page__header" />
  <div class="home-page__wrapper">
    <app-home-sidebar class="home-page__sidebar" [links]="links()"/>
    <div
      #bodyContainer
      class="home-page__body"
      [class.home-page__body--no-scroll]="isEditInventoryPage()"
    >
      <router-outlet />
    </div>
  </div>
</div>
